//TODO: DELETE THIS FILE AFTER EXPERIMENT IS MERGED
import experiments from 'experiment';
import OldDynamicPagesComboBox from './oldDynamicPagesComboBox';
import NewDynamicPageComboBox from './newDynamicPagesComboBox';
import React from 'react';
import createReactClass from 'create-react-class';
import type { Dispatch } from 'types/redux';

import type {
  TpaInnerRouteData,
  CurrentTpaInnerRoutesInfo,
} from '#packages/stateManagement';
import type { EditorState } from '#packages/stateManagement';
import * as stateManagement from '#packages/stateManagement';
import * as util from '#packages/util';
import * as core from '#packages/core';
import type { SitemapEntry } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import type { PageRef } from '@wix/document-services-types';

const { getStageLayout } = stateManagement.domMeasurements.selectors;

const { getPreviewMode } = stateManagement.preview.selectors;

type InnerRoute = SitemapEntry | TpaInnerRouteData;

interface DynamicPagesComboBoxProps {
  innerRef: React.RefObject<React.ReactInstance>;
  previewMode: boolean;
  editorIsInit: boolean;
  devModeContext: unknown;
  stageLayout?: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
  innerRoutes: InnerRoute[];
  selectedInnerRoute?: string;
  routerId?: string;
  tpaInfo?: CurrentTpaInnerRoutesInfo;
  setSelectedInnerRoute: (innerRoute: string, routerId: string) => void;
  style?: React.CSSProperties;
  onDragStart?: () => void;
  onDragEnd?: () => void;
}
export const INFRA = {
  TPA_LINKS: 'tpa_link',
  DYNAMIC_PAGES: 'dynamic_pages',
};

// eslint-disable-next-line react/prefer-es6-class
const DynamicPagesComboBox = createReactClass<DynamicPagesComboBoxProps>({
  displayName: 'dynamicPagesComboBox',
  render() {
    const props = this.state.props || this.props;

    const Comp = experiments.isOpen('se_updatingDynamicPagesComboBox')
      ? NewDynamicPageComboBox
      : OldDynamicPagesComboBox;

    return <Comp {...props} ref={this.props.innerRef} />;
  },
  componentDidMount() {
    this.setState({ props: this.props });
  },
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ props: this.props });
    }
  },
  updateProps(props: Partial<DynamicPagesComboBoxProps>) {
    this.setState({ props: { ...this.state.props, ...props } });
  },
  mixins: [core.mixins.editorAPIMixin, util.draggableMixin],
});

const getInnerRoutesProps = (state: EditorState) => {
  const routerId = stateManagement.dynamicPages.selectors.getRouterId(state);
  if (routerId) {
    return {
      innerRoutes: stateManagement.dynamicPages.selectors.getInnerRoutes(state),
      selectedInnerRoute:
        stateManagement.dynamicPages.selectors.getSelectedInnerRoute(state),
      routerId,
    };
  }

  const selectedInnerRoute =
    stateManagement.tpaDynamicPages.selectors.getSelectedRouteInfo(state)?.path;
  if (selectedInnerRoute) {
    const tpaInfo =
      stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(state);
    return {
      innerRoutes:
        stateManagement.tpaDynamicPages.selectors.getFocusedInnerRoutes(
          state,
          tpaInfo.appDefinitionId,
          tpaInfo.pageId,
          'dynamicPagesNavBar',
        ),
      selectedInnerRoute,
      tpaInfo,
    };
  }

  return {
    innerRoutes: [] as InnerRoute[],
  };
};

const getEditorAPI = (
  dispatch: Dispatch,
  getState: EditorState,
  {
    editorAPI,
  }: {
    editorAPI: EditorAPI;
  },
) => editorAPI;

const mapDispatchToProps = (dispatch: AnyFixMe) => {
  const editorAPI = dispatch(getEditorAPI);

  return {
    setSelectedInnerRoute: (newRoute: string, routerId: string) => {
      const platformAPI = editorAPI.host.getAPI(
        EditorPlatformHostIntegrationAPI,
      );
      const currentPageRef = editorAPI.pages.getReference(
        editorAPI.dsRead.pages.getCurrentPageId(),
      ) as PageRef;
      const isVariantOrReplacerPage =
        !!platformAPI.pageReplace.getOriginalPageRef(currentPageRef);

      if (routerId) {
        dispatch(
          stateManagement.dynamicPages.actions.setSelectedInnerRouteAndNavigate(
            newRoute,
            routerId,
            isVariantOrReplacerPage ? currentPageRef.id : undefined,
          ),
        );
      } else {
        dispatch(
          stateManagement.tpaDynamicPages.actions.setCurrentUrlToState(
            newRoute,
            true,
          ),
        );
      }
    },
  };
};

const mapStateToProps = ({ state }: { state: EditorState }) => ({
  ...getInnerRoutesProps(state),
  stageLayout: getStageLayout(state),
  isPreview: getPreviewMode(state),
});

const Connected = util.hoc.connect(
  util.hoc.STORES.STATE_ONLY,
  mapStateToProps,
  mapDispatchToProps,
)(DynamicPagesComboBox);
Connected.pure = DynamicPagesComboBox;
export default Connected;

export type FullDynamicPagesComboBoxProps = React.ComponentProps<
  typeof Connected
>;
